<template>
  <!-- 提货详情 -->
  <div class="pickUp-detail">
    <detailEdit 
      v-if="[undefined, 'add', 'edit'].includes(routeQuery.action)"
      :options="options"
      :dataForm="dataForm"
      ref="detailEdit"
    ></detailEdit>

    <detailView
      v-if="routeQuery.action === 'view'"
      :options="options"
      :dataForm="dataForm"
      ref="detailView"
    ></detailView>

    <ab-upload
      v-if="uploadParams.items && uploadParams.items.length > 0"
      :params="uploadParams"
      :disabled="routeQuery.action === 'view'"
      @update-billsId="updateBillsId" 
      ref="fileUpload"
    ></ab-upload>

    <ab-footer>
      <el-button @click="back">返回</el-button>

      <el-button
        v-if="!this.dataForm.status || this.dataForm.status === 1"
        :loading="btnLoading"
        @click="saveFn()"
      >保存</el-button>

      <el-button
        v-if="!this.dataForm.status || this.dataForm.status === 1"
        type="primary"
        :loading="btnLoading"
        @click="submitFn()"
      >提交</el-button>

      <el-button
        type="primary"
        v-if="this.dataForm.status === 2"
        :loading="btnLoading"
        @click="withdraw()"
      >撤回</el-button>
    </ab-footer>
  </div>
</template>

<script>
import detailEdit from './pickUp-detail-edit.vue'
import detailView from './pickUp-detail-view.vue'

export default {
  name: 'pickUp-detail',
  components: {
    detailEdit,
    detailView,
  },

  data() {
    return {
      routeQuery: {},
      options: {},
      dataForm: {},
      tempBillId: null,
      uploadParams: {
        coreBillIds: '',
        coreBillNumbers: '',
        sourceBillId: '',
        sourceBillNumber: '',
        sourceBillType: 'deliveryNotice',
        billType: '',
        items: []
      },
      btnLoading: false
    }
  },

  computed: {
    mainTabs: {
      get() {
        return this.$store.state.mainTabs
      },
      set(val) {
        this.$store.commit('updateMainTabs', val)
      }
    },

    mainTabsActiveName: {
      get() {
        return this.$store.state.mainTabsActiveName
      },
      set(val) {
        this.$store.commit('updateMainTabsActiveName', val)
      }
    }
  },
  
  watch: {
    $route(to, from) {
      if (to.path === '/pickUp-detail') {
        this.routeQuery = Object.keys(to.query).length ? to.query : this.routeQuery
        if (this.routeQuery.cache && this.routeQuery.cache !== 'false') {
          return false
        } else {
          this.routeQuery.cache = true
        }
        if (
          typeof this.routeQuery.cache === "string"
            ? JSON.parse(this.routeQuery.cache)
            : this.routeQuery.cache
        ) {
          return false
        } else {
          this.routeQuery.cache = true
        }
        this.init()
      }
    }
  },

  mounted() {
    this.getSelectList()
  },

  activated () {
    let query = this.$route.query || {}
    this.routeQuery = Object.keys(query).length ? query : this.routeQuery
    if (
      typeof this.routeQuery.cache === "string"
        ? JSON.parse(this.routeQuery.cache)
        : this.routeQuery.cache
    ) {
      return false
    } else {
      this.routeQuery.cache = true
    }
    this.init()
  },

  methods: {
    removeTabHandle(tabName) {
      this.mainTabs = this.mainTabs.filter(item => item.index !== tabName)
      if (tabName) {
        this.$router.push({ path: '/pickUp-list' })
      }
    },

    getSelectList() {
      this.$get('/sys/dictData/getByTypes',{
        typeNumbers: 'transportType,carType'
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.options = data.result
        } else {
          this.options = {}
        }
      })
    },

    init() {
      if (this.routeQuery.id) { // 编辑/详情
        this.getDetail(this.routeQuery.id).then(data => {
          this.dataForm = data.result
          this.initUpload()
        })
      } else { // 新增
        let bizType = JSON.parse(sessionStorage.getItem('bizType') || '{}')

        this.dataForm = {
            bizTypeGroup: bizType.activeIndex || '02'
        }
        this.initUpload()
      }
    },

    getDetail(id) {
      return new Promise((resolve, reject) => {
        this.$get('/tms/deliveryNotice/get', { id }).then(({ data }) => {
          if (data.code === 'C0000') {
            resolve(data)
          } else {
            reject(data.message)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },

    initUpload() {
      // 初始化上传组件
      this.uploadParams.sourceBillId = this.dataForm.id
      this.uploadParams.sourceBillNumber = this.dataForm.number

      setTimeout(() => {
        let items = [
          {
            title: '其它资料',
            attachType: '010',
            required: false,
            message: '(若为海运柜，请上传BOOKING)'
          }
        ]
        this.uploadParams.items = items
      }, 500)
    },

    // 附件临时id
    updateBillsId(tempBillId) {
      this.tempBillId = tempBillId
    },

    // 返回
    back() {
      this.removeTabHandle(this.mainTabsActiveName)
    },

    // 保存
    saveFn() {
      this.$refs.detailEdit.$refs.dataForm.validate(valid => {
        if (valid) {
          this.btnLoading = true
          this.saveForm().then(data => {
            this.routeQuery.id = this.dataForm.id || data.result
            this.$message({
              message: data.message,
              type: 'success',
              offset: 380,
              grouping: true
            })
            this.back()
          }).finally(() => {
            this.btnLoading = false
          })
        }
      })
    },

    saveForm() {
      return new Promise((resolve, reject) => {
        let params = Object.assign({}, this.dataForm)
        params.sourceType = '2'
        if (this.tempBillId) {
          params.tempBillId = this.tempBillId
        }
        if (params.addressIdList && params.addressIdList.length > 0) {
          params.addressIds = params.addressIdList.join(',')
        }
        this.$post('/tms/deliveryNotice/add', params).then(({ data }) => {
          if (data && data.code === 'C0000') {
            resolve(data)
          } else {
            reject(data.message)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },

    // 提交
    submitFn() {
      this.$refs.detailEdit.$refs.dataForm.validate(valid => {
        if (valid) {
          this.btnLoading = true
          if (!this.routeQuery.id) { // 直接新增-提交
            this.saveForm().then(data => {
              this.getDetail(data.result).then(data => {
                this.dataForm = data.result
                this.submitForm()
              }).catch(err => {
                this.btnLoading = false
              })
            }).catch(err => {
              this.btnLoading = false
            })
          } else {
            this.submitForm()
          }
        }
      })
    },

    submitForm() {
      let params = Object.assign({}, this.dataForm)
      params.sourceType = '2'
      if (params.addressIdList && params.addressIdList.length > 0) {
        params.addressIds = params.addressIdList.join(',')
      }
      this.$post('/tms/deliveryNotice/submit', params).then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.$message({
            message: data.message,
            type: 'success',
            offset: 380,
            grouping: true
          })
          this.back()
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },

    // 撤回
    withdraw() {
      this.$confirm('确认撤回吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info ',
      }).then(() => {
        this.$post('/tms/deliveryNotice/revoke', {
          id: this.dataForm.id
        }, this, 'btnLoading').then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.$message({
              message: data.message,
              type: 'success',
              offset: 380,
              grouping: true
            })
            this.back()
          }
        })
      }).catch(() => { })
    }
  }
}
</script>

<style lang="scss">
.pickUp-detail {
  .ab-file-upload {
    .upload {
      margin-bottom: 40px;
    }
  }
  .footer {
    padding: 20px 0;
  }
}
</style>
